/* 百度统计代码
 */
const _hmt = _hmt || []
window._hmt = _hmt
;(function() {
  const host = location.hostname
  // dev
  let hmtId = '767d1fb3b4675954296f027ef6fabe0b' // test
  if (host === 'shitouji.bluestonehk.com') hmtId = '64ac1baf844fbc8514b36350cab9af5c' // test2
  if (host === 'shitouji2.bluestonehk.com') hmtId = '41272aeb4b999e5b4bb25cd11a1cc6aa' // prod
  if (host === 'www.bluestonehk.com') hmtId = '9321c711a4f401f17788fc0677a29829'

  const hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?' + hmtId
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()




// WEBPACK FOOTER //
// ./src/utils/hmt.js